import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import _ from "lodash";
import Cookies from "js-cookie";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faInfoCircle, faPlusCircle, faTrash } from "@fortawesome/free-solid-svg-icons";

import { Col, Row, Form, Button, InputGroup, ListGroup, Alert, OverlayTrigger, Modal, Accordion } from "react-bootstrap";
import { infoTooltip } from "../InfoTooltip";

import {formDataFormatter} from "../data/formDataFormatter";
import BookingService from "../../services/booking.service";

import Preloader from "../Preloader";

import suggestedListingText from "../data/suggestedListingText.json";
import { statesList } from "../data/statesList";

export const ManageListing = (props) => {
  let currentUserData = Cookies.get('authToken');
  currentUserData = currentUserData ? JSON.parse(currentUserData).data : null;
  let authToken = currentUserData.accessToken;

  const [formData, setFormData] = useState({});

  function setFormValues(e) {
    formData[e.target.name] = formDataFormatter(e);
    setFormData(formData);
  }

  function setFormAddressValues(e) {
    if (formData.address == {}) (formData.address = props.listingData.address);

    const newFormData = {
      ...formData,
      address: {
        ...formData.address || props.listingData.address,
        [e.target.name]: formDataFormatter(e)
      }
    };

    setFormData(newFormData);
  }

  const [beginDate, setBeginDate] = useState(0);
  useEffect(() => {
    setBeginDate(props.listingData.startAvailable);
  }, [props.listingData.startAvailable]);
  const changeBeginDate = (e) => {
    setBeginDate(e.toDate());
    formData['startAvailable'] = e.toDate();
    setFormData(formData);
  };

  const [endDate, setEndDate] = useState(0);
  useEffect(() => {
    setEndDate(props.listingData.endAvailable);
  }, [props.listingData.endAvailable]);
  const changeEndDate = (e) => {
    setEndDate(e.toDate());
    formData['endAvailable'] = e.toDate();
    setFormData(formData);
  };

  const [blackoutModal, setBlackoutModal] = useState(false);  
  const [blackoutBookings, setBlackoutBookings] = useState([]);
  const [blackoutBeginDate, setBlackoutBeginDate] = useState(0);
  const [blackoutEndDate, setBlackoutEndDate] = useState(0);

  const addBlackoutDates = () => {
    props.addBooking('blackout', blackoutBeginDate, blackoutEndDate)
    setBlackoutModal(false)
    setBlackoutBeginDate(0)
    setBlackoutEndDate(0)
  }
  const removeBlackoutDates = (id) => {
    BookingService.removeBooking(id, authToken)
      .then(res => {
        if (res.status === 200) {
          const updatedListingData = {
            ...props.listingData,
            bookings: props.listingData.bookings.filter(booking => booking._id !== id)
          };
          props.setListingData(updatedListingData);        
        } else {
          alert("Booking " + id + " was not removed.");
        }
      })
  }

  useEffect(() => {
    if (blackoutBeginDate && !blackoutEndDate) setBlackoutEndDate(moment(blackoutBeginDate).toDate())
  }, [blackoutBeginDate]);

  useEffect(() => {
    if ( props.listingData.bookings && props.listingData.bookings.length > 0 ) {
      const newBlackoutBookings = props.listingData.bookings.filter(booking => booking.blackout === true);
      setBlackoutBookings(newBlackoutBookings);
    }
  }, [props.listingData.bookings])

  var isValidEndDate = function(current) {
    // check date ISN'T BEFORE START DATE
    if ( beginDate || props.listingData.startAvailable ) {
      let startAvailable = beginDate?moment(beginDate):moment(props.listingData.startAvailable);
      if ( current < startAvailable ) return false;
    }
    return true;
  };

  const isValidBlackoutBeginDate = function(current) {
    // check if existing bookings exist for this date
    if ( props.listingData.bookings && props.listingData.bookings.length > 0 ) {
      const existingBookings = props.listingData.bookings.filter(booking => {
        return booking.start && booking.end && moment(current).isBetween(moment(booking.start).subtract(1, 'days'), moment(booking.end), null, '[]');
      });
      if ( existingBookings.length > 0 ) { return false; }
    }

    // check date is AFTER START OF AVAILABILITY
    if ( props.listingData.startAvailable ) {
      let startAvailable = moment(props.listingData.startAvailable);
      if ( current < startAvailable ) { return false; }
    }

    // check date is BEFORE END OF AVAILABILITY
    if ( props.listingData.endAvailable ) {
      let endAvailable = moment(props.listingData.endAvailable);
      if ( current > endAvailable ) { return false; }
    }

    // check date is NOT BEFORE TODAY
    const today = moment().subtract( 1, 'day' );
    if ( !current.isAfter( today ) ) { return false; }

    return true;
  };

  const isValidBlackoutEndDate = function(current) {

    // check date is AFTER START OF AVAILABILITY
    if ( props.listingData.startAvailable ) {
      let startAvailable = moment(props.listingData.startAvailable);
      if ( current < startAvailable ) { return false; }
    }

    // check date is BEFORE END OF AVAILABILITY
    if ( props.listingData.endAvailable ) {
      let endAvailable = moment(props.listingData.endAvailable);
      if ( current > endAvailable ) { return false; }
    }

    // check date is NOT TODAY OR EARLIER
    const tomorrow = moment().add( 1, 'day' );
    if ( !current.isAfter(tomorrow) ) { return false; }

    // check date is AFTER BLACKOUT START DATE
    if ( blackoutBeginDate ) {
      let blackoutStart = moment(blackoutBeginDate).subtract(2, 'day');
      if ( current < blackoutStart ) { return false; }
    }

    // check blackout start to end period doesn't overlap with existing bookings
    if ( props.listingData.bookings && props.listingData.bookings.length > 0 ) {
      const overlappingBookings = props.listingData.bookings.filter(booking => {
        return booking.start && booking.end && moment(current).isBetween(moment(booking.start).subtract(1, 'days'), moment(booking.end), null, '[]');
      });
      if ( overlappingBookings.length > 0 ) { return false; }
    }

    return true;
  };


  const weekdaysList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const [weekdaysAvailable, setWeekdaysAvailable] = useState([]);
  useEffect(() => {
    setWeekdaysAvailable(props.listingData.weekdaysAvailable);
  }, [props.listingData.weekdaysAvailable]);

  function setWeekdaysAvailableValue(e) {
    const checkedState = e.target.checked;
    // store state into local
    let currentWeekdaysAvailable = weekdaysAvailable?weekdaysAvailable:[];

    if ( !currentWeekdaysAvailable.includes(e.target.value) && checkedState ) {
      currentWeekdaysAvailable = _.concat(currentWeekdaysAvailable, e.target.value);
    } else {
      currentWeekdaysAvailable = currentWeekdaysAvailable.filter(day => day !== e.target.value);
    }

    setWeekdaysAvailable(currentWeekdaysAvailable);
    formData['weekdaysAvailable'] = currentWeekdaysAvailable;
    setFormData(formData);
  };



  const [checkInTime, setCheckInTime] = useState("");
  useEffect(() => {
    let isMounted = true;
    if (isMounted) setCheckInTime(props.listingData.check_in_time);
    return () => { isMounted = false };
  }, [props.listingData.check_in_time]);

  const [checkOutTime, setCheckOutTime] = useState("");
  useEffect(() => {
    let isMounted = true;
    if (isMounted) setCheckOutTime(props.listingData.check_out_time);
    return () => { isMounted = false };
  }, [props.listingData.check_out_time]);

  useEffect(() => {
    const updatedFormData = {
      ...formData,
      check_in_time: checkInTime,
      check_out_time: checkOutTime,
    }
    setFormData(updatedFormData);
  }, [checkInTime, checkOutTime]);

  const [autoApproval, setAutoApproval] = useState(0);
  useEffect(() => {
    setAutoApproval(props.listingData.auto_approval);
  }, [props.listingData.auto_approval]);

  function setAutoApprovalValue(e) {
    setFormValues(e);
    setAutoApproval(e.target.auto_approval);
  }


  const [state, setState] = useState(0);
  useEffect(() => {
    setState(props.listingData.address && props.listingData.address.state);
  }, [props.listingData.address]);

  function setStateValue(e) {
    setFormAddressValues(e);
    setState(e.target.value);
  }


  const [listingTypeOptionsSelected, setListingTypeOptionsSelected] = useState([]);
  useEffect(() => {
    setListingTypeOptionsSelected(props.listingData.listingType);
  }, [props.listingData.listingType]);


  function listingTypeCheckboxChange(e, refreshOnly = false) {
    const checkedState = e.target.checked;
    // store state into local
    let currentListingTypeOptionsSelected = listingTypeOptionsSelected?listingTypeOptionsSelected:[];

    if ( !refreshOnly && currentListingTypeOptionsSelected && !currentListingTypeOptionsSelected.includes(e.target.value) && checkedState ) {
      currentListingTypeOptionsSelected = _.concat(currentListingTypeOptionsSelected, e.target.value);
    } else {
      currentListingTypeOptionsSelected = currentListingTypeOptionsSelected.filter(type => type !== e.target.value);
    }

    setListingTypeOptionsSelected(currentListingTypeOptionsSelected);
    formData['listingType'] = currentListingTypeOptionsSelected;
    setFormData(formData);
  };


  const updateListingData = (e) => {
    props.updateListing(formData);
    
    // clear submitted data for next form submit
    setFormData({});
  }

  const [listingModalOpen, setListingModalOpen] = useState(false);

  const listingTypeOptions = (props) => {
    return (
      <>
        <Row>
          <Col className="mb-1">
            <h5>Listing Categories & Searchable Terms</h5>
          </Col>
        </Row>

        <Row>
          <Col className="mb-3">
            <Form.Group>
              <ListGroup horizontal className="flex-wrap">
                {
                  Object.keys(props.listingTypesDefinitions).map(function (l, i) {
                    let thisListingType = props.listingTypesDefinitions[l];
                    return (
                      <ListGroup.Item key={i}>
                        <Form.Check
                          name="listingType"
                          type="switch"
                          id={thisListingType.id}
                          label={thisListingType.type.title}
                          value={thisListingType.id}
                          checked={ listingTypeOptionsSelected && listingTypeOptionsSelected.includes(l) }
                          onChange={listingTypeCheckboxChange}
                        />
                      </ListGroup.Item>
                    );
                  })
                }
              </ListGroup>
            </Form.Group>
          </Col>
        </Row>
      </>
    );
  }


  const [listingTypeDataObj, setListingTypeDataObj] = useState({});
  useEffect(() => {
    if ( props.listingData.listingTypeData ) {
      setListingTypeDataObj(props.listingData.listingTypeData);
    }
  }, [props.listingData.listingTypeData]);

  const updateListingTypeFormField = (e, field, listingTypeId) => {

    const checkedState = e.target.checked;
    // store state into local
    let currentListingTypeDataObjSelected = listingTypeDataObj;

/*
    // without listener, input loses focus upon each keystroke
    if ( ['string', 'number'].includes(field.type) ) {
      const updatedField = document.getElementById('listingTypeFieldInput-'+listingTypeId+'-'+fieldId);
      updatedField.addEventListener('focusout', (e) => {
        if ( !currentListingTypeDataObjSelected.hasOwnProperty(listingTypeId) ) currentListingTypeDataObjSelected[listingTypeId] = {};
        currentListingTypeDataObjSelected[listingTypeId][fieldId] = e.target.value;
      });
    }
*/
    if ( field.type === 'checkbox' ) {
      // Create array if not set up yet for checkbox group
      if ( !currentListingTypeDataObjSelected.hasOwnProperty(listingTypeId)  ) currentListingTypeDataObjSelected[listingTypeId] = {};
      if ( !currentListingTypeDataObjSelected[listingTypeId].hasOwnProperty(e.target.name) || !currentListingTypeDataObjSelected[listingTypeId][e.target.name].length ) {
        currentListingTypeDataObjSelected[listingTypeId][e.target.name] = [];
      }
      if ( !currentListingTypeDataObjSelected[listingTypeId][e.target.name].includes(e.target.value) && checkedState ) {
        // Add value to array for checkbox group
        currentListingTypeDataObjSelected[listingTypeId][e.target.name].push(e.target.value);
      } else {
        // Remove value from array for checkbox group
        currentListingTypeDataObjSelected[listingTypeId][e.target.name] = currentListingTypeDataObjSelected[listingTypeId][e.target.name].filter(el => el !== e.target.value);
      }

    } else if ( currentListingTypeDataObjSelected && !currentListingTypeDataObjSelected.hasOwnProperty(e.target.value) && checkedState ) {
      // Add item+value to object
      currentListingTypeDataObjSelected = _.merge(currentListingTypeDataObjSelected, {[listingTypeId]: {[e.target.name]: e.target.value}});
    } else {
      // Remove item+value from object
      delete currentListingTypeDataObjSelected[listingTypeId][e.target.name];
    }

    setListingTypeDataObj(currentListingTypeDataObjSelected);
    formData['listingTypeData'] = currentListingTypeDataObjSelected;
    setFormData(formData);

    // Nudge data to force live refresh
    listingTypeCheckboxChange(e, true);

  }

  const updateListingTypeSpecifcationFormField = (e, field, listingTypeId, fieldId) => {
    const checkedState = e.target.checked;
    // store state into local
    let currentListingTypeDataObjSelected = listingTypeDataObj;

    // Create array if not set up yet for checkbox group
    if ( !currentListingTypeDataObjSelected.hasOwnProperty(listingTypeId) ) currentListingTypeDataObjSelected[listingTypeId] = {};
    if ( !currentListingTypeDataObjSelected[listingTypeId].hasOwnProperty(fieldId+'_specifications') || !currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'].length ) {
      currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'] = [];
    }
    if ( !currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'].includes(e.target.value) && checkedState ) {
      // Add value to array for checkbox group
      currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'].push(e.target.value);
    } else {
      // Remove value from array for checkbox group
      currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'] = currentListingTypeDataObjSelected[listingTypeId][fieldId+'_specifications'].filter(el => el !== e.target.value);
    }

    setListingTypeDataObj(currentListingTypeDataObjSelected);
    formData['listingTypeData'] = currentListingTypeDataObjSelected;
    setFormData(formData);
    // Nudge data to force live refresh
    listingTypeCheckboxChange(e, true);
  }

  const formFields = (field, fieldId, listingTypeId) => {

    switch ( field.type ) {

      default:
        return null;

      case 'boolean':
        return (
          <>
            <Row>
              <Col className="mb-3">
                <Form.Group className={'listingType-field-'+fieldId}>
                  <Form.Check
                    type="switch" 
                    label={field.title} 
                    name={fieldId}
                    value="true" 
                    id={'listingTypeFieldInput-'+listingTypeId+'-'+fieldId} 
                    checked={(listingTypeDataObj[listingTypeId] && listingTypeDataObj[listingTypeId].hasOwnProperty(fieldId) && listingTypeDataObj[listingTypeId][fieldId] === "true")?true:null} 
                    onChange={(e) => { updateListingTypeFormField(e, field, listingTypeId) }}
                  >
                  </Form.Check>
                </Form.Group>
              </Col>
            </Row>

            {
            field.hasOwnProperty('specifications') && 
            listingTypeDataObj && listingTypeDataObj.hasOwnProperty(listingTypeId) && 
            listingTypeDataObj[listingTypeId].hasOwnProperty(fieldId) && 
            listingTypeDataObj[listingTypeId][fieldId] === 'true' &&
              <Row>
                <Col className="mb-3">
                  <Form.Group className={'listingType-field-'+fieldId+'-specifications'}>
                    <Form.Label className="d-block mb-1">{field.title} Specifications:</Form.Label>
                    {
                      Object.keys(field.specifications).map(function (specification, i) {
                        return (
                          <Form.Check
                            inline
                            className="text-capitalize"
                            key={fieldId+'_'+specification}
                            name={fieldId+'_'+specification}
                            type="checkbox"
                            id={fieldId+'_'+specification}
                            label={field.specifications[specification]}
                            value={specification}
                            checked={ (listingTypeDataObj[listingTypeId] && listingTypeDataObj[listingTypeId][fieldId] && listingTypeDataObj[listingTypeId][fieldId+'_specifications'] && listingTypeDataObj[listingTypeId][fieldId+'_specifications'].includes(specification)) ? true : null }
                            onChange={(e) => { updateListingTypeSpecifcationFormField(e, field, listingTypeId, fieldId) }}
                          />
                        );
                      })
                    }
                  </Form.Group>
                </Col>
              </Row>
            }

          </>
        );


      case 'checkbox':
        return (
          <Row>
            <Col className="mb-3">
              <Form.Group className={'listingType-field-'+fieldId}>
                <Form.Label className="d-block mb-1">{field.title}:</Form.Label>
                {
                  Object.keys(field.specifications).map(function (specification, i) {
                    return (
                      <Form.Check
                        inline
                        className="text-capitalize"
                        key={fieldId+'_'+specification}
                        name={fieldId}
                        type="checkbox"
                        id={fieldId+'_'+specification}
                        label={field.specifications[specification]}
                        value={specification}
                        checked={listingTypeDataObj[listingTypeId] && listingTypeDataObj[listingTypeId][fieldId] && listingTypeDataObj[listingTypeId][fieldId].includes(specification)}
                        onChange={(e) => { updateListingTypeFormField(e, field, listingTypeId) }}
                      />
                    );
                  })
                }
              </Form.Group>
            </Col>
          </Row>
        );
/*
      case 'string':
      default:
        return (
          <Row>
            <Col className="mb-3">
              <Form.Group className={'listingType-field-'+fieldId}>
                <Form.Label>{field.title}:</Form.Label>
                <Form.Control 
                  as="textarea" 
                  rows={3} 
                  type="text" 
                  id={'listingTypeFieldInput-'+listingTypeId+'-'+fieldId} 
                  defaultValue={listingTypeDataObj[listingTypeId] && listingTypeDataObj[listingTypeId][fieldId]} 
                  onChange={(e) => { updateListingTypeFormField(e, field, listingTypeId, fieldId) }} 
                />
              </Form.Group>
            </Col>
          </Row>
        );

      case 'number':
        return (
          <Row>
            <Col className="mb-3">
              <Form.Group className={'listingType-field-'+fieldId}>
                <Form.Label>{field.title}:</Form.Label>
                <Form.Control 
                  type="number" 
                  id={'listingTypeFieldInput-'+listingTypeId+'-'+fieldId} 
                  defaultValue={listingTypeDataObj[listingTypeId] && listingTypeDataObj[listingTypeId][fieldId]} 
                  onChange={(e) => { updateListingTypeFormField(e, field, listingTypeId, fieldId) }} 
                />
              </Form.Group>
            </Col>
          </Row>
        );
*/
    }

  }

  const [modalOpen, setModalOpen] = useState(false);
  const [currentField, setCurrentField] = useState('');

  const getStateFullName = (state) => {
    const stateName = Object.keys(statesList).find(key => statesList[key] === state);
    return stateName ? stateName : state;
  }

  const insertPropertyVariables = (text) => {
    const replacedText = text
      .replace(/\[Property Name\]/g, props.listingData.propertyData.title)
      .replace(/\[Region\/Location\]/g, getStateFullName(props.listingData.address.state))
      .replace(/\[Landowner Name\]/g, props.listingData.hostData.firstName + ' ' + props.listingData.hostData.lastName)
      .replace(/\[Check-In Time\]/g, moment(props.listingData.check_in_time).isValid() ? moment(props.listingData.check_in_time).format("hh:mm A") : 'the agreed upon check-in time')
      .replace(/\[Check-Out Time\]/g, moment(props.listingData.check_out_time).isValid() ? moment(props.listingData.check_out_time).format("hh:mm A") : 'the agreed upon check-out time')
    return replacedText;
  }

  const [listingTextFields, setListingTextFields] = useState({
    description: props.listingData.description || '',
    rules: props.listingData.rules || '',
    check_in_protocol: props.listingData.check_in_protocol || '',
    check_out_protocol: props.listingData.check_out_protocol || '',
    cancellation_policy: props.listingData.cancellation_policy || '',
    rules_regulations_waivers: props.listingData.rules_regulations_waivers || '',
    welcome_message: props.listingData.welcome_message || '',
    thankyou_message: props.listingData.thankyou_message || '',
  });

  useEffect(() => {
    setListingTextFields({
      description: props.listingData.description || '',
      rules: props.listingData.rules || '',
      check_in_protocol: props.listingData.check_in_protocol || '',
      check_out_protocol: props.listingData.check_out_protocol || '',
      cancellation_policy: props.listingData.cancellation_policy || '',
      rules_regulations_waivers: props.listingData.rules_regulations_waivers || '',
      welcome_message: props.listingData.welcome_message || '',
      thankyou_message: props.listingData.thankyou_message || '',
    });
  }, [props.listingData]);

  const updateTextFields = (name, value) => {
    setListingTextFields(prev => ({ ...prev, [name]: value }));
  };

  const refreshModalContent = (fieldName) => {
    setCurrentField(fieldName);
    setModalOpen(true);
  }

  const formatSuggestedText = (text) => {  
    text = insertPropertyVariables(text);
    const lines = text.split('\n').map(line => line.trim()).filter(Boolean);

    const listItems = [];
    const content = [];
  
    lines.forEach((line, i) => {
      const isBullet = /^(\•|\✔|\d+\.)\s*/.test(line);
      if (isBullet) listItems.push(<li>{line.replace(/^(\•|\✔|\d+\.)\s*/, '')}</li>);
      else {
        if (listItems.length > 0) {
          content.push(<ul>{[...listItems]}</ul>);
          listItems.length = 0;
        }
        content.push(<p>{line}</p>);
      }
    });
  
    if (listItems.length > 0) {
      content.push(<ul>{listItems}</ul>);
    }
  
    return <>{content}</>;
  };

  const ListingTypes = (props) => {
    const listingTypeObj = props.listingTypesDefinitions;

    if ( listingTypeOptionsSelected && Object.keys(listingTypeOptionsSelected).length > 0 ) {

      return (
        <>
          {

            Object.values(listingTypeOptionsSelected).map(function(fieldId) {
              return (

                <div key={'listingType-'+fieldId}>

                  { listingTypeObj[fieldId] &&
                    <>
                      <Row>
                        <Col className="mb-1">
                          <h5>{listingTypeObj[fieldId].type.title} Details</h5>
                          {listingTypeObj[fieldId].type.description &&
                            <div className="mb-3 mx-2 text-italic">
                              {listingTypeObj[fieldId].type.description}
                            </div>
                          }
                        </Col>
                      </Row>

                      <div id={'listingType-group-'+listingTypeObj[fieldId].id}>
                          {
                            Object.keys(listingTypeObj[fieldId].fields).map(function (field) {
                              return (
                                <>
                                  {formFields(listingTypeObj[fieldId].fields[field], field, fieldId)}
                                </>
                              );
                            })
                          }
                      </div>
                    </>
                  }

                </div>
              );
            })
          }
        </>
      );

    } else {
      return (<></>);
    }

  }

  return (
    <>
      <Row>
        <Col>
          {(props.queryStatus !== 200)
            ?
              <Preloader message="Loading..." logoSize={50} show={true} />
            :
              <Form id="updateListing" onSubmit={ (e) => updateListingData(e.preventDefault()) }>

                <Row>
                  <Col md={12} lg={6}>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="title">
                          <Form.Label className="d-flex">
                            <span>Listing Title</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("This title is the first thing guests will see when searching for listings. Keep it clear, inviting, and descriptive to attract interest.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>                  
                          </Form.Label>
                          <Form.Control name="title" required type="text" defaultValue={props.listingData.title} placeholder="Listing Title" onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center">
                        <h5>Dates of Availability:</h5>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="startDate">
                          <Form.Label>Start Date</Form.Label>
                          <Datetime
                            dateFormat="MM/DD/YYYY"
                            timeFormat={false}
                            onChange={changeBeginDate}
                            closeOnSelect={true}

                            renderInput={(props, openCalendar, closeCalendar) => (
                              <InputGroup>
                                <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                <Form.Control
                                  type="text"
                                  defaultValue={ ( beginDate ) ? moment(beginDate).format("MM/DD/YYYY") : "" }
                                  placeholder="MM/DD/YYYY"
                                  onFocus={openCalendar}
                                  onChange={(e) => { setBeginDate(e.target.value) }}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="endDate">
                          <Form.Label>End Date</Form.Label>
                          <Datetime
                            dateFormat="MM/DD/YYYY"
                            timeFormat={false}
                            onChange={changeEndDate}
                            closeOnSelect={true}
                            isValidDate={isValidEndDate}

                            renderInput={(props, openCalendar, closeCalendar) => (
                              <InputGroup>
                                <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                <Form.Control
                                  type="text"
                                  defaultValue={ ( endDate ) ? moment(endDate).format("MM/DD/YYYY") : "" }
                                  placeholder="MM/DD/YYYY"
                                  onFocus={openCalendar}
                                  onChange={(e) => { setEndDate(e.target.value) }}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <label className="d-block text-center mb-1">Weekdays Available:</label>
                        <Form.Group className="weekdaysAvailable d-flex flex-wrap">
                          {
                            weekdaysList.map(function (day, i) {
                              return (
                                <Form.Check
                                  inline
                                  className="text-capitalize"
                                  key={day}
                                  name="weekdaysAvailable"
                                  type="checkbox"
                                  id={day}
                                  label={day}
                                  value={day}
                                  checked={weekdaysAvailable && weekdaysAvailable.includes(day)}
                                  onChange={setWeekdaysAvailableValue}
                                />
                              );
                            })
                          }
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <label className="d-block text-center mb-1">Blackout Dates</label>
                      <Modal show={blackoutModal} size="lg" onHide={() => setBlackoutModal(false)} centered>
                        <Modal.Header closeButton>
                          <Modal.Title>Set Blackout Dates</Modal.Title>
                          </Modal.Header>
                        
                        <Form onSubmit={() => addBlackoutDates()}>
                          <Row className="d-flex pt-3 px-3">
                            <Col md={6} className="mb-3">
                              <Form.Group id="endDate">
                                <Form.Label>Blackout Start Date</Form.Label>
                                <Datetime
                                  dateFormat="MM/DD/YYYY"
                                  timeFormat={false}
                                  onChange={(e) => setBlackoutBeginDate(e.toDate())}
                                  closeOnSelect={true}
                                  isValidDate={isValidBlackoutBeginDate}
                                  value={moment()}

                                  renderInput={(props, openCalendar, closeCalendar) => (
                                    <InputGroup>
                                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        defaultValue={ ( blackoutBeginDate ) ? moment(blackoutBeginDate).format("MM/DD/YYYY") : "" }
                                        placeholder="MM/DD/YYYY"
                                        onFocus={openCalendar}
                                        required
                                      />
                                    </InputGroup>
                                  )}
                                />
                              </Form.Group>
                            </Col>

                            <Col md={6} className="mb-3">
                              <Form.Group id="endDate">
                                <Form.Label>Blackout End Date</Form.Label>
                                <Datetime
                                  dateFormat="MM/DD/YYYY"
                                  timeFormat={false}
                                  onChange={(e) => setBlackoutEndDate(e.toDate())}
                                  closeOnSelect={true}
                                  isValidDate={isValidBlackoutEndDate}
                                  value={blackoutBeginDate}

                                  renderInput={(props, openCalendar, closeCalendar) => (
                                    <InputGroup>
                                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        defaultValue={ ( blackoutEndDate ) ? moment(blackoutEndDate).format("MM/DD/YYYY") : "" }
                                        placeholder="MM/DD/YYYY"
                                        onFocus={openCalendar}
                                        required
                                      />
                                    </InputGroup>
                                  )}
                                />
                              </Form.Group>
                            </Col>

                            <Col xs={12} lg={6} className="d-flex justify-content-center mb-3 mx-auto">
                              <Button
                                variant="primary"
                                type="submit"
                                className="w-100 w-md-50"
                              >
                                Confirm Dates
                              </Button>
                            </Col>

                          </Row>
                        </Form>
                      </Modal>

                      <Col xs={12} className="d-flex flex-column justify-content-center">
                        {blackoutBookings && blackoutBookings
                          .slice()
                          .sort((a, b) => new Date(a.start) - new Date(b.start))
                          .filter(booking => moment(booking.end).isSameOrAfter(moment()))
                          .map(booking => (
                            <ListGroup.Item key={booking._id} id="blackout-list" className="d-flex align-items-center p-0 pt-1 mx-auto justify-content-between">
                              <div>{moment(booking.start).format("MMMM Do")} – {moment(booking.end).format("MMMM Do, YYYY")}</div>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeBlackoutDates(booking._id)}
                                className="py-1 px-2"
                              >
                              <FontAwesomeIcon icon={faTrash}/> 
                              </Button>
                            </ListGroup.Item>
                          ))
                        }

                        <a className="text-center pt-1" onClick={() => setBlackoutModal(true)}>+ Add Dates</a>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="description">
                          <Form.Label className="d-flex">
                            <span>Description</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Briefly describe your property and what makes it special. Highlight unique features, activities, and amenities to help guests imagine their experience.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>  
                          </Form.Label>
                          <Form.Control value={listingTextFields.description} onChange={(e) => { updateTextFields('description', e.target.value); setFormValues(e) }} name="description" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                  </Col>

                  <Col md={12} lg={6}>
                    <Row>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="price">
                          <Form.Label>Price (daily rate)</Form.Label>
                          <Form.Control name="base_rate" type="number" step="0.01" min="0" placeholder="Price" defaultValue={props.listingData.base_rate && props.listingData.base_rate} onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="maxGuests">
                          <Form.Label>Guests Limit</Form.Label>
                          <Form.Control name="max_guests" type="number" step="1" min="0" defaultValue={props.listingData.max_guests !== 0 ? props.listingData.max_guests:null} onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="minDays">
                          <Form.Label>Minimum Days</Form.Label>
                          <Form.Control name="min_days" type="number" step="1" min="0" defaultValue={props.listingData.min_days} placeholder="1" onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="maxDays">
                          <Form.Label>Maximum Days</Form.Label>
                          <Form.Control name="max_days" type="number" step="1" min="0" defaultValue={props.listingData.max_days} placeholder="1" onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="check-in-time">
                          <Form.Label>Check-In Time</Form.Label>
                          <Datetime
                            dateFormat={false}
                            timeFormat={true}
                            value={checkInTime ? moment(checkInTime) : null}
                            onChange={(e) => setCheckInTime(e)}
                            closeOnSelect={true}

                            renderInput={(props, openCalendar, closeCalendar) => (
                              <InputGroup>
                                <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                <Form.Control
                                  type="text"
                                  value={ checkInTime ? moment(checkInTime).format("hh:mm A") : "" }
                                  onFocus={openCalendar}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="check-out-time">
                          <Form.Label>Check-Out Time</Form.Label>
                          <Datetime
                            dateFormat={false}
                            timeFormat={true}
                            value={checkOutTime ? moment(checkOutTime) : null}
                            onChange={(e) => setCheckOutTime(e)}
                            closeOnSelect={true}

                            renderInput={(props, openCalendar, closeCalendar) => (
                              <InputGroup>
                                <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                                <Form.Control
                                  type="text"
                                  value={ checkOutTime ? moment(checkOutTime).format("hh:mm A") : "" }
                                  onFocus={openCalendar}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={6} className="mb-3">
                        <Form.Group id="booking-lead-time" onChange={setFormValues} onBlur={setFormValues}>
                          <Form.Label className="d-flex">
                            <span>Booking Lead Time (days)</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Set the minimum number of days in advance that guests must book before their arrival. This helps you prepare for their visit")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>                  
                          </Form.Label>
                          <Form.Control name="booking_lead_time" type="number" step="1" min="0" defaultValue={props.listingData.booking_lead_time} />
                        </Form.Group>
                      </Col>
                      <Col sm={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="d-flex">
                            <span>Auto Approval</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Choose whether booking requests are automatically approved if available or if you prefer to manually review and accept each request.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>                  
                          </Form.Label>                          
                          <Form.Select name="auto_approval" id="auto-approval" value={autoApproval} onChange={setAutoApprovalValue}>
                            <option value={true}>Auto</option>
                            <option value={false}>Manual</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                  </Col>
                </Row>

                <hr />

                { listingTypeOptions(props) }

                <ListingTypes {...props} />

                <hr />

                <Row>
                  <Col>
                    <h5>Additional Details</h5>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} lg={6}>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="rules">
                          <Form.Label className="d-flex">
                            <span>Rules</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Clearly outline the rules for your property to ensure guest safety and protect your land. Consider guidelines on smoking, littering, noise levels, pet policies, and any other important regulations.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>                  
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('rules')}>Suggested Text</a>                
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.rules} onChange={(e) => { updateTextFields('rules', e.target.value); setFormValues(e) }} name="rules" as="textarea" rows={3} type="text" placeholder="Rules" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="check-in-protocol">
                          <Form.Label className="d-flex">
                            <span>Check-In Protocol</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Provide instructions for guests to follow when arriving at your property. Include details on gate access, parking, or any required check-in procedures.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>       
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('check_in_protocol')}>Suggested Text</a>                           
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.check_in_protocol} onChange={(e) => { updateTextFields('check_in_protocol', e.target.value); setFormValues(e) }} name="check_in_protocol" as="textarea" rows={3} type="text" placeholder="Check-In Protocol" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="check-out-protocol">
                          <Form.Label className="d-flex">
                            <span>Check-Out Protocol</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Outline the steps guests should take when leaving your property. Mention any cleanup requirements, key returns, or final inspections.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>    
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('check_out_protocol')}>Suggested Text</a>                                         
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.check_out_protocol} onChange={(e) => { updateTextFields('check_out_protocol', e.target.value); setFormValues(e) }} name="check_out_protocol" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="cancellation-policy">
                        <Form.Label className="d-flex">
                            <span>Cancellation Policy</span> 
                            <OverlayTrigger
                              placement="left"
                              overlay={infoTooltip("Define the terms for cancellations, including notice periods, refund eligibility, and any fees. Clear policies help manage expectations and prevent misunderstandings")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger> 
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('cancellation_policy')}>Suggested Text</a>                                            
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.cancellation_policy} onChange={(e) => { updateTextFields('cancellation_policy', e.target.value); setFormValues(e) }} name="cancellation_policy" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="regulations-requirements-waivers">
                          <Form.Label className="d-flex">
                            <span>Regulations, Requirements, & Waivers</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("List any important requirements guests must follow, including necessary permits or licenses. Use this section to mention any waivers that must be completed before participation.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger> 
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('rules_regulations_waivers')}>Suggested Text</a>                                            
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.rules_regulations_waivers} onChange={(e) => { updateTextFields('rules_regulations_waivers', e.target.value); setFormValues(e) }} name="rules_regulations_waivers" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                  </Col>

                  <Col md={12} lg={6}>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="welcome-message">
                        <Form.Label className="d-flex">
                            <span>Welcome Email</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Write a warm and inviting message to welcome guests to your property. Share your excitement about hosting them and set a positive tone for their upcoming experience.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>  
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('welcome_message')}>Suggested Text</a>                                           
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.welcome_message} onChange={(e) => { updateTextFields('welcome_message', e.target.value); setFormValues(e) }} name="welcome_message" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="thankyou-message">
                          <Form.Label className="d-flex">
                            <span>Thank You Email</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Show appreciation to your guests for visiting your property. A friendly thank-you message can leave a lasting impression and encourage future visits.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>   
                            <a className="ms-2 text-gray-600" onClick={() => refreshModalContent('thankyou_message')}>Suggested Text</a>                                          
                          </Form.Label>                          
                          <Form.Control value={listingTextFields.thankyou_message} onChange={(e) => { updateTextFields('thankyou_message', e.target.value); setFormValues(e) }} name="thankyou_message" as="textarea" rows={3} type="text" onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="mb-3">
                        <Form.Group id="driving-directions">
                          <Form.Label className="d-flex">
                            <span>Driving Directions</span> 
                            <OverlayTrigger
                              placement="right"
                              overlay={infoTooltip("Provide clear directions from the nearest easily recognizable main road to your property’s check-in point.")}
                            >
                              <a className="text-warning ms-2"><FontAwesomeIcon icon={faInfoCircle}/></a>
                            </OverlayTrigger>                  
                          </Form.Label>                          
                          <Form.Control name="driving_directions" as="textarea" rows={3} type="text" placeholder="Driving Directions" defaultValue={props.listingData.driving_directions} onChange={setFormValues} onBlur={setFormValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={12} className="mb-3">
                        <Form.Group id="address">
                          <Form.Label>Street Address</Form.Label>
                          <Form.Control name="street_address" type="text" placeholder="Street address" defaultValue={props.listingData.address && props.listingData.address.street_address} onChange={setFormAddressValues} onBlur={setFormAddressValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={4} className="mb-3">
                        <Form.Group id="city">
                          <Form.Label>City</Form.Label>
                          <Form.Control name="city" type="text" placeholder="City" defaultValue={props.listingData.address && props.listingData.address.city} onChange={setFormAddressValues} onBlur={setFormAddressValues} />
                        </Form.Group>
                      </Col>
                      <Col sm={4} className="mb-3">
                        <Form.Group className="mb-2">
                          <Form.Label>State</Form.Label>
                          <Form.Select name="state" id="state" value={state} onChange={setStateValue} onBlur={setStateValue}>
                            <option value="0">State</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <Form.Group id="zip">
                          <Form.Label>Zip Code</Form.Label>
                          <Form.Control name="zipcode" type="tel" placeholder="Zip Code" defaultValue={props.listingData.address && props.listingData.address.zipcode} onChange={setFormAddressValues} onBlur={setFormAddressValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="county">
                          <Form.Label>County</Form.Label>
                          <Form.Control name="county" type="text" placeholder="County" defaultValue={props.listingData.address && props.listingData.address.county} onChange={setFormAddressValues} onBlur={setFormAddressValues} />
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group id="nearest_city">
                          <Form.Label>Nearest Major City</Form.Label>
                          <Form.Control name="nearest_city" type="text" placeholder="Major City" defaultValue={props.listingData.address && props.listingData.address.nearest_city} onChange={setFormAddressValues} onBlur={setFormAddressValues} />
                        </Form.Group>
                      </Col>
                    </Row>

                  </Col>
                </Row>

                <Modal size="xl" show={modalOpen}>
                  <Modal.Header closeButton onHide={()=>setModalOpen(false)}>
                    <Modal.Title>Select a Template</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Accordion defaultActiveKey="0">
                      {suggestedListingText[currentField]?.map((option, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index}>
                          <Accordion.Header className="text-dark">
                            <div>
                              <div className="fs-4"><strong>{option.title}</strong></div>
                              <div className="mt-2">
                                {insertPropertyVariables(option.body.slice(0, 100))}...
                              </div>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {formatSuggestedText(option.body)}
                            <Button className="btn-success" onClick={()=> {
                              const replacedText = insertPropertyVariables(option.body);
                              setFormValues({target:{ name:currentField, value:replacedText }})
                              updateTextFields(currentField, replacedText);
                              setModalOpen(false) 
                            }}>Use This Template</Button>  
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Modal.Body>
                </Modal>

                <div className="fixed-bottom bg-white border-top border-2 py-2 mt-3">

                  { props.alertMessage && 
                    <Row className="justify-content-center">
                      <Col xs={11} md={10} className="d-flex justify-content-center text-center">
                        <Alert 
                          variant="secondary"
                          onClose={() => props.setAlertMessage(false)}
                          dismissible
                          className="w-100"
                        >
                            <>
                                {props.alertMessage} 
                            </>
                        </Alert>
                      </Col>
                    </Row>
                  }

                  <Row className="justify-content-center">
                    <Col lg={6} className="d-sm-flex justify-content-evenly text-center">

                      <Button variant="success" type="submit" className="d-block d-sm-inline-block mx-auto mx-sm-1 my-2 my-sm-0 px-4" 
                        onClick={() => {
                          props.setModalType('Update')
                          !props.listingData.active ? setListingModalOpen(true) : props.setAlertMessage('Listing Updated')
                        }}>Update</Button>
                      <Button variant="secondary" className="d-block d-sm-inline-block mx-auto mx-sm-1 my-2 my-sm-0 px-4 text-white" 
                        onClick={() => {
                          props.setModalType('Duplicate')
                          setListingModalOpen(true)
                        }}>Duplicate Listing</Button>

                      { props.listingData.active
                        ?
                          <Button variant="warning" className="px-4" onClick={() => {
                            props.setModalType('Deactivate')
                            setListingModalOpen(true)
                          }}>Deactivate</Button>
                        :
                          <Button variant="danger" className="d-block d-sm-inline-block mx-auto mx-sm-1 my-2 my-sm-0 px-4" 
                            onClick={() => {
                              props.setModalType('Delete')
                              setListingModalOpen(true)
                            }}>Delete</Button>
                      }

                    </Col>
                  </Row>

                  <Modal show={listingModalOpen} onHide={() => setListingModalOpen(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <FontAwesomeIcon icon={props.modalType === 'Delete' ? faTrash : faPlusCircle}  className="me-2"/> 
                        {props.modalType} Listing
                      </Modal.Title>  
                    </Modal.Header>
                    <Modal.Body className="justify-content-center text-center">
                      {props.modalType === 'Update' && (
                        <>
                          <p>Your listing has been updated.</p>
                          <p>Ready to publish? This will make your listing visible to the public and available for bookings.</p>  
                          <Button variant="success" className="me-2" onClick={() => {
                            props.updateListingStatus(true);
                            setListingModalOpen(false);
                          }}>
                            Publish Now
                          </Button>
                          <Button variant="danger" onClick={() => {
                            setListingModalOpen(false);
                          }}>
                            Close
                          </Button>
                        </>
                      )}

                      {props.modalType === 'Duplicate' && (
                        <>
                          <p>Do you want to duplicate your listing?</p>
                          <Button variant="secondary" className="text-white" onClick={() => {
                            props.duplicateListing()
                            setListingModalOpen(false)
                          }}>
                            Duplicate Listing
                          </Button>
                        </>
                      )}

                      {props.modalType === 'Deactivate' && (
                        <>
                          <p>Are you sure you want to deactivate your listing? Customers will no longer be able to view or book this listing.</p>
                          <Button variant="warning" 
                          onClick={() => {
                            props.updateListingStatus(false);
                            setListingModalOpen(false)
                          }}
                          >
                            Deactivate Listing
                          </Button>
                        </>
                      )}

                      {props.modalType === 'Delete' && (
                        <>
                          <p>Are you sure you want to delete your listing? All Bookings associated with this Listing will be removed.</p> 
                          <p>This action cannot be undone.</p>
                          <Button variant="danger" onClick={() => {
                            props.removeListing(props.listingData._id)
                            setListingModalOpen(false)
                          }}>
                            Delete Listing
                          </Button>
                        </>
                      )}
                    </Modal.Body>
                  </Modal>
                </div>

              </Form>
          }
        </Col>
      </Row>
    </>
  );
}